import { render } from "./AtNdaComponent.vue?vue&type=template&id=18c12a3c&scoped=true"
import script from "./AtNdaComponent.vue?vue&type=script&lang=js"
export * from "./AtNdaComponent.vue?vue&type=script&lang=js"

import "./AtNdaComponent.vue?vue&type=style&index=0&id=18c12a3c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-18c12a3c"

export default script